import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./contexts/AuthContext";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const { token, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="loading-data">
        <p>Loading...</p>
      </div>
    );
  }

  return token ? <Component {...rest} /> : <Navigate to="/log-in" />;
};

export default PrivateRoute;